import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Scanner from '@Components/Common/BarcodeReader/scanner';
import beep from '../../../media/audio/start.mp3';

import './style.scss';

function BarcodeScannerListener({
  tenantDepartmentId, selectedTenant, excludeOutOfStock, excludedProducts, disabled,
  productTypes, isSalesProduct, isPurchaseProduct, filterReservedQuantity, onSearch,
}) {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleShortcut = (event) => {
      if (
        (event.altKey || event.metaKey)
        && event.key === 'i'
      ) {
        if (!disabled) {
          setIsActive(true);
          event.preventDefault(); // Prevent the browser's default behavior.
        }
      }
    };

    document.addEventListener('keydown', handleShortcut);

    return () => {
      document.removeEventListener('keydown', handleShortcut);
    };
  }, [disabled]);

  const audio = new Audio(beep);
  useEffect(() => {
    if (isActive) {
      audio.play();
    }
  }, [isActive]);
  return (
    <div
      className={`scanner-wrapper ${isActive ? 'scanner-wrapper-active' : ''} ${disabled ? 'scanner-wrapper-disabled' : ''}`}
      onClick={() => {
        setIsActive(true);
      }}
    >
      {isActive ? (
        <Scanner
          tenantDepartmentId={tenantDepartmentId}
          selectedTenant={selectedTenant}
          excludeOutOfStock={excludeOutOfStock}
          productTypes={productTypes}
          isSalesProduct={isSalesProduct}
          isPurchaseProduct={isPurchaseProduct}
          filterReservedQuantity={filterReservedQuantity}
          excludedProducts={excludedProducts}
          onSearch={(tenantSku) => {
            onSearch(tenantSku);
          }}
          toggleScanner={() => setIsActive(false)}
        />
      ) : (
        <div className="scanner-inactive">
          <FontAwesomeIcon icon={faBarcode} />
        </div>
      )}
      &nbsp;
      <div className={`scanner-text ${isActive ? 'scanner-text__active' : ''}`}>
        {isActive ? 'Scanning...' : 'Start Scanner'}
        {!isActive && <div className="scanner-text__subscript">Alt + I</div>}
      </div>
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  searchResults: ProductReducers.searchResults,
  searchProductsLoading: ProductReducers.searchProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({

});

BarcodeScannerListener.propTypes = {
  user: PropTypes.any,
  tenantDepartmentId: PropTypes.any,
  selectedTenant: PropTypes.any,
  excludeOutOfStock: PropTypes.bool,
  productTypes: PropTypes.string,
  isSalesProduct: PropTypes.bool,
  isPurchaseProduct: PropTypes.bool,
  filterReservedQuantity: PropTypes.bool,
  onSearch: PropTypes.func,
  disabled: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BarcodeScannerListener));
